<template>
  <div class="region-list">
    <div
      class="region-item"
      :class="{'region-item-default-style':useDefaultStyle,'is-active':item.isSelect}"
      :title="item.namec||''"
      @click="clickItem(item,index)"
      v-for="(item,index) in pagingList"
      :key="index"
    >
      <slot name="item" :index="index" :item="item">
        {{item.namec||"-"}}
      </slot>
    </div>
    <el-pagination
      v-if="list && list.length>pageSize"
      style="text-align: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalListNum"
    />
  </div>
</template>

<script>
import {isArray} from "my-tools-kit";
let headerCellStyle = { background: '#F3F3F3', color: '#999999' };
export default {
  name: "selectRegionList",
  props:{
    list:Array,
    useDefaultStyle:{
      type:Boolean,
      default:true,
    },
  },
  data(){
    return {
      headerCellStyle,
      /* 分页参数 */
      pageSizes: [50,100,150,200],
      pageSize: 100,
      currentPage: 1,
    }
  },
  computed:{
    pagingList(){
      let list = this.list;
      if(!isArray(list) || !list.length) return [];
      let start = this.pageSize * (this.currentPage - 1);
      let end = this.pageSize * this.currentPage;
      return list.slice(start,end);
    },
    totalListNum(){
      let list = this.list||[];
      return list.length
    },
  },
  watch:{
    list(){
      this.handleCurrentChange();
    },
  },
  methods:{
    /**
     * pageSize 改变时会触发：选择每页显示条数
     */
    handleSizeChange(val, type) {
      this.pageSize = val;
      this.handleCurrentChange();
    },
    /**
     * currentPage 改变时会触发：选择页数
     */
    handleCurrentChange(val = 1, type) {
      this.currentPage = val;
    },

    clickItem(item,index){
      this.$emit("clickItem",item,index)
    }
  },
}
</script>

<style scoped lang="scss">
.region-list{
  .region-item{

  }
  /deep/ .region-item-default-style{
    display: inline-block;
    padding: 4px 10px;
    margin: 0 4px 4px 0;
    border-radius: 4px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover{
      color: #FF4D01;
      border-color: #e3b0b5;
    }
    &.is-active{
      color: #fff;
      background-color: #FF4D01;
      border-color: #FF4D01;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/selectRegion/selectRegionList.vue